import { i18n } from "services/i18nService";

import { initialErrorState } from "views/common";

export function isValid(record) {
  const errors = initialErrorState();
  errors.entity = [];

  if (!record.number || !record.number.trim().length) {
    errors.messages.push(i18n("isValid.upsAccount.number"));
    errors.entity.push("number");
  }

  return errors;
}
